import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutExtraPayChangeCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableChangeCompareItems: Table;
}
